import React from "react";
import Hero from "./Hero";
import Product3DViewer from "./Product3DViewer";
import Universe from "./Universe";

function ProductsPage() {
  return (
    <>
      <Hero />
      
      <div className="container mx-auto py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Kite */}
          <div className="p-4 bg-white rounded-lg shadow-md">
            <Product3DViewer
              productName="Kite"
              productDescription="Our ultra-fast flagship trading platform with streaming market data, advanced charts, an elegant UI, and more. Enjoy the Kite experience seamlessly on your Android and iOS devices."
              initialColor="#5468ff"
            />
            <div className="mt-4 flex justify-between">
              <a href="#" className="text-blue-500 hover:underline">Try Demo</a>
              <a href="#" className="text-blue-500 hover:underline">Learn More</a>
            </div>
            <div className="mt-4 flex space-x-4">
              <a href="#"><img src="media/images/googlePlayBadge.svg" alt="Google Play" /></a>
              <a href="#"><img src="media/images/appstoreBadge.svg" alt="App Store" /></a>
            </div>
          </div>
          
          {/* Console */}
          <div className="p-4 bg-white rounded-lg shadow-md">
            <Product3DViewer
              productName="Console"
              productDescription="The central dashboard for your Zerodha account. Gain insights into your trades and investments with in-depth reports and visualisations."
              initialColor="#43a047"
            />
            <div className="mt-4">
              <a href="#" className="text-blue-500 hover:underline">Learn More</a>
            </div>
          </div>
          
          {/* Coin */}
          <div className="p-4 bg-white rounded-lg shadow-md">
            <Product3DViewer
              productName="Coin"
              productDescription="Buy direct mutual funds online, commission-free, delivered directly to your Demat account. Enjoy the investment experience on your Android and iOS devices."
              initialColor="#ff9800"
            />
            <div className="mt-4 flex justify-between">
              <a href="#" className="text-blue-500 hover:underline">Try Demo</a>
              <a href="#" className="text-blue-500 hover:underline">Learn More</a>
            </div>
            <div className="mt-4 flex space-x-4">
              <a href="#"><img src="media/images/googlePlayBadge.svg" alt="Google Play" /></a>
              <a href="#"><img src="media/images/appstoreBadge.svg" alt="App Store" /></a>
            </div>
          </div>
          
          {/* Kite Connect API */}
          <div className="p-4 bg-white rounded-lg shadow-md">
            <Product3DViewer
              productName="Kite Connect API"
              productDescription="Build powerful trading platforms and experiences with our super simple HTTP/JSON APIs. If you are a startup, build your investment app and showcase it to our clientbase."
              initialColor="#e91e63"
            />
            <div className="mt-4">
              <a href="#" className="text-blue-500 hover:underline">Learn More</a>
            </div>
          </div>
          
          {/* Varsity */}
          <div className="p-4 bg-white rounded-lg shadow-md">
            <Product3DViewer
              productName="Varsity mobile"
              productDescription="An easy to grasp, collection of stock market lessons with in-depth coverage and illustrations. Content is broken down into bite-size cards to help you learn on the go."
              initialColor="#9c27b0"
            />
            <div className="mt-4 flex space-x-4">
              <a href="#"><img src="media/images/googlePlayBadge.svg" alt="Google Play" /></a>
              <a href="#"><img src="media/images/appstoreBadge.svg" alt="App Store" /></a>
            </div>
          </div>
        </div>
      </div>
      
      <p className="text-center p-2 p-md-5 mt-5 mb-5 fs-5">
        Want to know more about our technology stack? Check out the Zerodha.tech blog.
      </p>
      
      <Universe />
    </>
  );
}

export default ProductsPage;